<template>
  <div>
    <el-row type="flex" align="middle">
      <el-col :span="22">
        <div class="formTitle"
             style="margin: 0 0 20px; display: flex; justify-content: space-between;align-items: center;">
          {{
            mixinUserInfo.platformType === 3 ? formProtocol.title :
                $const.PROTOCOLTYPE.get(formProtocol.usePage).title
          }}

          <div style="margin:20px 0">
            <el-switch v-model="formProtocol.status" :active-value="1" :inactive-value="2"
                       :disabled="$const.PROTOCOLTYPE.get(formProtocol.usePage).disabled"></el-switch>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="blueInfo" style="margin: 10px 0 20px 0; width: auto">
      <p
          v-html="mixinUserInfo.platformType === 3 ? formProtocol.remark : $const.PROTOCOLTYPE.get(formProtocol.usePage).desc">
      </p>
    </div>

    <div>
      <div style="display: flex; align-items: center;"> {{ formProtocol.title }}概述
        <el-tooltip class="item" effect="dark" content="乘客下单时弹窗展示乘车须知概述" placement="top"
                    style="margin-left: 8px;">
          <i style="font-size: 16px;" class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <div style="margin-top: 10px;">
        <wangeditor5 :showToolbar="true" :content.sync="formProtocol.summary" :height="200"></wangeditor5>
        <!--                <el-input type="textarea" :rows="4" v-model="formProtocol.summary" maxlength="100"></el-input>-->
      </div>
    </div>


    <div style="margin-top: 20px;">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px">
        <span>{{ formProtocol.title }}全文</span>
        <div>
          <el-button size="mini" icon="el-icon-upload2" @click="triggerMdImport">导入 Markdown 文件</el-button>
          <input ref="mdFileInput" type="file" accept=".md,.markdown,.txt" style="display:none"
                 @change="handleMdFileImport" />
        </div>
      </div>
      <div>
        <wangeditor5 ref="contentEditor" :content.sync="formProtocol.content" styleObject="height: calc(100vh - 380px)"></wangeditor5>
      </div>
    </div>

    <div class="saveBtn">
      <el-button type="primary" :loading="saveStatus" @click="protocolSave">
        保存
      </el-button>
    </div>
  </div>
</template>
<script>
import wangeditor5 from "@/components/wangeditor5.vue";
import { marked } from 'marked';

export default {
  name: 'protocolDetail',
  components: {wangeditor5},
  data() {
    return {
      saveStatus: false,
      formProtocol: {usePage: 1, content: null, status: null, summary: null},
    }
  },
  created() {
    console.log(this.$route)
    let url = "/api/v1/manage/systems/userAgreement/" + this.$route.query.id;
    this.$axios.get(url).then(res => {
      this.formProtocol = res.data;
    })
  },
  methods: {
    triggerMdImport() {
      this.$refs.mdFileInput.value = '';
      this.$refs.mdFileInput.click();
    },
    handleMdFileImport(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (evt) => {
        const mdContent = evt.target.result;
        const html = marked.parse(mdContent, { breaks: true, gfm: true });
        this.formProtocol.content = html;
        if (this.$refs.contentEditor && this.$refs.contentEditor.setMarkdownContent) {
          this.$refs.contentEditor.setMarkdownContent(mdContent);
        }
        this.$message.success('Markdown 文件导入成功，已转换为富文本');
      };
      reader.readAsText(file, 'UTF-8');
    },
    // 协议保存
    async protocolSave() {
      let url = "/api/v1/manage/systems/userAgreement";
      if (this.formProtocol.content || this.formProtocol.status == 2) {
        this.saveStatus = true;
        let params = this.$utils.deepCopyFn(this.formProtocol);
        let data = await this.$axios.post(url, params);
        this.saveStatus = false;
        if (data && data.code === 1) {
          this.$router.back();
        }
      } else {
        this.$message.info('请先编辑协议内容')
      }

    },
  }
}
</script>

<style lang="less">
.saveBtn {
  text-align: right;
  margin: 20px 0;
}
</style>
